import WebhookEndpointCrud from "../components/webhook-endpoint/WebhookEndpointCrud";

const WebhookEndpointsPage = () => {
  return (
    <>
      <WebhookEndpointCrud />
    </>
  );
};

export default WebhookEndpointsPage;
